class BritishColumbiaObstetricalFileAllergiesMedications {
    public Allergies: string = "";
    public Medications: string = "";
    public BeliefsPractices: string = "";
    public HasNoAllergies: boolean;
    public HasPreconceptionFolicAcid: boolean;
    public HasT1FolicAcid: boolean;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileAllergiesMedications>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileAllergiesMedications };
